"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAlertService = exports.useService = exports.ServiceProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const alert_service_1 = __importDefault(require("./alert-service"));
const alertService = new alert_service_1.default();
// provider
const ServiceContext = (0, react_1.createContext)({});
const ServiceProvider = ({ children, value }) => ((0, jsx_runtime_1.jsx)(ServiceContext.Provider, { value: value || { AlertService: alertService }, children: children }));
exports.ServiceProvider = ServiceProvider;
exports.ServiceProvider.propTypes = {
    children: prop_types_1.default.node.isRequired,
    value: prop_types_1.default.object
};
// injections
function useService(identifier = 'AlertService') {
    const context = (0, react_1.useContext)(ServiceContext);
    const service = context[identifier];
    if (!service)
        throw new Error('No service exists with that name.');
    return service;
}
exports.useService = useService;
function useAlertService() {
    return useService('AlertService');
}
exports.useAlertService = useAlertService;
